import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify from 'vuetify'
import VueCookies from 'vue-cookies'

import GetpolisConstants from "./plugins/GetpolisConstants";
import MultiFiltersPlugin from './plugins/MultiFilters'

// Helpers
//import colors from 'vuetify/es5/util/colors'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
window.Vue = Vue;

import VueMask from 'v-mask'

Vue.use(VueMask, {
    placeholders: {
        V: /[0-9ABCDEFGHJKLMNPRSTUVWXYZ\*]/i,
        G: /[АВЕКМНОРСТУХ_\*]/i,
        Q: /[0-9_\*]/i,
        N: /[\dABCDEFGHIJKLMNPQRSTUVWXYZ-]/i,
        S: /[АБВГДЕЖЗИКЛМНОПРСТУФХЦЧШЩЭЮЯ]/i,
        P: /[0-9\*]/i
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(Vuetify, {
    theme: {
        primary: '#00ba57',
        secondary: '#00ba57',
        accent: '#00ba57'
    },
    iconfont: 'md'
});

Vue.use(VueCookies);
VueCookies.config('30d');

Vue.use(GetpolisConstants);
Vue.use(MultiFiltersPlugin);

import HeaderComponent from './components/elements/HeaderComponent.vue';
import OsagoCompanyPage from './components/pages/OsagoCompany.vue';
import OsagoFaqPage from './components/pages/OsagoFaq.vue';
import QuestionsElement from './components/elements/Questions.vue';
import FeedbackElement from './components/elements/Feedback.vue';
import OsagoContactsPage from './components/pages/OsagoContacts.vue';
import B2bLandingPage from './components/pages/B2bLanding.vue';
import InfoCarouselElement from './components/elements/InfoCarousel.vue';
import OsagoPartnersElement from './components/elements/Partners.vue';

Vue.component('header-component', HeaderComponent);
Vue.component('osago-company-page', OsagoCompanyPage);
Vue.component('osago-faq-page', OsagoFaqPage);
Vue.component('home-questions', QuestionsElement);
Vue.component('homepage-feedback', FeedbackElement);
Vue.component('osago-contacts-page', OsagoContactsPage);
Vue.component('b2b-landing-page', B2bLandingPage);
Vue.component('info-carousel', InfoCarouselElement);
Vue.component('osago-partners', OsagoPartnersElement);

const app = new Vue({
    el: '#app'
});





// WEBPACK FOOTER //
// ./resources/js/info.js